var _circle, _rect, _path, _path2, _rect2, _path3, _rect3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethodIcon = function SvgPaymentMethodIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 50,
    fill: "none",
    viewBox: "0 0 46 50"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 29.5,
    r: 20.5,
    fill: "#E5E5FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.754,
    height: 17.503,
    x: 16.164,
    y: 24.932,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 3.5,
    transform: "rotate(-65.103 16.164 24.932)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    d: "M21.42 27.073 32.455 3.297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "m36.525 12.834 1.299-2.797"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 27.556,
    height: 24.111,
    x: 14.5,
    y: 17.889,
    fill: "#fff",
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M42.056 23.055V20.89a3 3 0 0 0-3-3H17.5a3 3 0 0 0-3 3v18.11a3 3 0 0 0 3 3h21.556a3 3 0 0 0 3-3v-3.314"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.074,
    height: 8.185,
    x: 29.926,
    y: 25.277,
    fill: "#fff",
    stroke: "#3D4355",
    rx: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.018,
    cy: 29.37,
    r: 1.148,
    fill: "#3D4355"
  })));
};
export default SvgPaymentMethodIcon;